module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "albums-filter clear media-filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterTitle),
      expression: "filterTitle"
    }],
    staticClass: "field",
    attrs: {
      "type": "text",
      "placeholder": _vm.$root.i18n.defaults.title
    },
    domProps: {
      "value": (_vm.filterTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterYear),
      expression: "filterYear"
    }],
    staticClass: "select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": ""
    }
  }, [_vm._v(_vm._s(_vm.$root.i18n.defaults.year))]), _vm._v(" "), _vm._l((_vm.$root.years), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterCategory),
      expression: "filterCategory"
    }],
    staticClass: "select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": ""
    }
  }, [_vm._v(_vm._s(_vm.$root.i18n.defaults.category))]), _vm._v(" "), _vm._l((_vm.$root.categories), function(category, id) {
    return _c('option', {
      domProps: {
        "value": id
      }
    }, [_vm._v(_vm._s(category))])
  })], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.albums.length) ? _c('ul', {
    staticClass: "list-albums"
  }, _vm._l((_vm.albums), function(album) {
    return _c('li', [_c('a', {
      attrs: {
        "href": album.href
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(album.image)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(album.title))])])])
  })) : _c('p', [_vm._v("\n\t\t" + _vm._s(_vm.$root.i18n.noAlbums) + "\n\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56f1c74a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/AlbumListing.vue
// module id = 7
// module chunks = 0